import { createContext, useContext } from "react";
import type { ServixSession, ServixUserType } from "../../core/session/session";

export type AuthSessionContextValue = {
	session: ServixSession | null;
	isAuthenticated: boolean;
	role: ServixUserType | null;
	status: "authenticated" | "anonymous";
	isLoading: boolean;
};

export const AuthSessionContext = createContext<AuthSessionContextValue | undefined>(
	undefined,
);

export function useAuthSessionContext(): AuthSessionContextValue {
	const context = useContext(AuthSessionContext);
	if (!context) {
		throw new Error("useAuthSessionContext must be used within AuthSessionProvider");
	}
	return context;
}
